import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import { InformationBoxComponent } from 'src/app/shared/information-box/information-box.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  changePasswordRequestForm: UntypedFormGroup;
  passwdChangeError: boolean = false;
  // passwordChangeMessage: string = '';
  // passwordChangeMessagebool: boolean = false;
  isValid: boolean = false;
  email;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.createPasswordRequestForm()
  }

  createPasswordRequestForm() {
    this.changePasswordRequestForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email,Validators.pattern(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
    });
  }

  validate() {
    this.isValid = true;
    if (this.changePasswordRequestForm.get('email').value == '') {
      this.isValid = false;
    }
    if (this.commonService.validEmail(this.email)) {
      this.isValid = false;
    }
  }

  closeCancel() {
    this.dialogRef.close({
      event: "save",
      save: false,
    });
  }

  changePasswordRequest() {
    if (this.changePasswordRequestForm.get('email').value == '') {
      // this.passwdChangeError = true;
      return;
    }
    let email = this.changePasswordRequestForm.value.email;

    this.authService.changeUserPasswordRequest(this.changePasswordRequestForm.value).subscribe(res => {
      this.changePasswordRequestForm.reset();
      if (!res) {
        // this.passwordChangeMessage = res.Success;
        // this.passwordChangeMessagebool = true;
        // this.passwdChangeError = false;
        this.dialogRef.close({
          event: "save",
          save: false,
        });
        let dialogRef = this.dialog.open(InformationBoxComponent, {
          width: '38em',
          autoFocus: false,
          panelClass: 'information-modalbox',
          data: {type:'emailComponent', email: email },
          disableClose: true,
        });
      }
    }, err => {
      // console.log(err)
      this.changePasswordRequestForm.reset();
      this.isValid = false;
    });
  }

}
